import { render } from "./ClientConfiguracionSecuenciales.vue?vue&type=template&id=61d9d7ed&scoped=true"
import script from "./ClientConfiguracionSecuenciales.vue?vue&type=script&lang=js"
export * from "./ClientConfiguracionSecuenciales.vue?vue&type=script&lang=js"

import "./ClientConfiguracionSecuenciales.vue?vue&type=style&index=0&id=61d9d7ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d9d7ed"]])

export default __exports__